module.exports = __webpack_public_path__ + "img/cn_1.11613aad.jpg";